import React from "react";
import { TableRow, TableCell, Box, Skeleton, Avatar } from "@mui/material";

const cellStyle = {
  padding: '10px 16px',
};

const DailyTotalsSkeleton = () => {
  return (
    <TableRow sx={{
      backgroundColor: '#fff',
      borderRadius: '10px',
    }}>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        minWidth: '32px', 
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <Skeleton variant="circular" width={20} height={20} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Skeleton width={20} />
      </TableCell>

      {/* Member Info Skeleton */}
      {/* <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box>
            <Skeleton width={100} height={20} />
            <Skeleton width={80} height={16} />
          </Box>
        </Box>
      </TableCell> */}

      {/* Project Info Skeleton */}
      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box>
            <Skeleton width={100} height={20} />
            <Skeleton width={80} height={16} />
          </Box>
        </Box>
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton width={60} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  

      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        textAlign: 'center',
        borderRadius: '0px 10px 10px 0px' 
      }}>
        <Skeleton width={80} />
      </TableCell>
    </TableRow>
  );
};

export default DailyTotalsSkeleton;
